import axios from 'axios';
import { trimAllValues } from "./helper";

import {} from '../contexts/app-context';

const headers = {}


const setAxiosDefaultHeaders = () => {

  
    axios.defaults.headers.common['Accept'] = '*/*';
    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    const sessionAuthToken: any = sessionStorage.getItem("SessionAuthToken");

    if (sessionAuthToken !== null && sessionAuthToken !== undefined && sessionAuthToken !== "") {
        const auth = JSON.parse(sessionAuthToken);
        axios.defaults.headers.common['Authorization'] = auth.accessToken;
        axios.defaults.headers.common['User-Agent-Id'] = btoa(auth.requestId);
    }
}

const API = {
    delete: (url: string, options: any = {}) => {
        setAxiosDefaultHeaders();
        const opts = {
            ...options,
            headers: {
                ...headers,
                ...options.headers,
            },
        }
        return axios.delete(url, opts)
    },
    get: (url: string, options: any = {}) => {
        setAxiosDefaultHeaders();
        const opts = {
            ...options,
            headers: {
                ...headers,
                ...options.headers,
            },
        }
        console.log(url);
        
        return axios.get(url, opts)
    },
    post: (url: string, options: any = {}, cancel: any = {}) => {
        setAxiosDefaultHeaders();
        options = trimAllValues(options);
        const opts = {
            ...options,
            headers: {
                ...headers,
                ...options.headers,
            },
        }
        return axios.post(url, opts, cancel)
    },
    postfile: (url: string, data: any, cancel: any = {}) => {
        setAxiosDefaultHeaders();
        const opts = {
            headers: {
                ...headers,
            },
        }
        return axios.post(url, data, opts)
    },
    put: (url: string, options: any = {}) => {
        setAxiosDefaultHeaders();
        const opts = {
            ...options,
            headers: {
                ...headers,
                ...options.headers,
            },
        }
        return axios.put(url, opts)
    },
}

export default API

